export type LoggedOutAlertObserver = () => void;

class LoggedOutAlertService {
  private static instance?: LoggedOutAlertService;
  private observers: LoggedOutAlertObserver[] = [];

  public attach(observer: LoggedOutAlertObserver) {
    this.observers.push(observer);
  }

  public detach(observer: LoggedOutAlertObserver) {
    this.observers = this.observers.filter(function(value: LoggedOutAlertObserver) {
      return value !== observer;
    });
  }

  public trigger() {
    this.observers.map(observer => observer());
  }

  public static getInstance(): LoggedOutAlertService {
    if (!LoggedOutAlertService.instance) {
      LoggedOutAlertService.instance = new LoggedOutAlertService();
    }
    return LoggedOutAlertService.instance;
  }
}

export default LoggedOutAlertService.getInstance();
